import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileMarkdownOutlinedSvg from "@ant-design/icons-svg/es/asn/FileMarkdownOutlined";
import AntdIcon from "../components/AntdIcon";
var FileMarkdownOutlined = function FileMarkdownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileMarkdownOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileMarkdownOutlined.displayName = 'FileMarkdownOutlined';
}
export default /*#__PURE__*/React.forwardRef(FileMarkdownOutlined);